import { useContext } from 'react'
import SspContext from 'selfServicePortal/contexts/SspContext'

export const useSspContext = () => {
	return useContext(SspContext)
}
